import { render } from "./contractPart.vue?vue&type=template&id=2bd25d65&scoped=true"
import script from "./contractPart.vue?vue&type=script&lang=js"
export * from "./contractPart.vue?vue&type=script&lang=js"

import "./contractPart.vue?vue&type=style&index=0&id=2bd25d65&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd25d65"]])

export default __exports__